import React from 'react';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  useTheme,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { styled } from '@mui/system';

const CustomAccordion = styled(Accordion)(({ theme }) => ({
  borderRadius: 12,
  boxShadow: 'none',
  border: '1px solid #d0e9dd',
  marginBottom: theme.spacing(2),
  '&:before': { display: 'none' },
  backgroundColor: '#f9fefa',
}));

const CustomSummary = styled(AccordionSummary)(({ theme }) => ({
  backgroundColor: '#E8FFF0',
  borderRadius: '12px',
  padding: theme.spacing(2),
  '& .MuiTypography-root': {
    fontWeight: 500,
    color: '#004d40',
    fontSize: '1rem',
  },
  '&:hover': {
    backgroundColor: '#d6f7e2',
    transition: '0.3s',
  },
}));

const CustomDetails = styled(AccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: '#ffffff',
  borderTop: '1px solid #d0e9dd',
  borderRadius: '0 0 12px 12px',
  color: '#333',
  fontSize: '0.95rem',
  lineHeight: 1.6,
}));

export default function AccordionFaq() {
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (_, isExpanded) =>
    setExpanded(isExpanded ? panel : false);

  const questions = [
    {
      key: 'panel1',
      title: 'Por quê fazer medições?',
      content:
        'As medições, seja da água ou a biometria, são importantes para analisar com precisão a evolução da produção. No Greenfy, você visualiza essas informações via gráficos no painel de controle.',
    },
    {
      key: 'panel2',
      title: 'Só consigo usar os parâmetros pré-estabelecidos?',
      content:
        'Não. Você tem total liberdade para adicionar os parâmetros que julgar necessários para sua fazenda.',
    },
    {
      key: 'panel3',
      title: 'O que é um ciclo e como funciona?',
      content:
        'O ciclo separa a produção em fases. Ao finalizar todos os estágios da produção do camarão, um ciclo é concluído.',
    },
    {
      key: 'panel4',
      title: 'Como funciona o formulário?',
      content:
        'O formulário permite salvar parâmetros usados com frequência, tornando o processo de medição mais rápido e padronizado.',
    },
    {
      key: 'panel5',
      title: 'Módulo de Contagem de Alevinos (Em desenvolvimento).',
      content:
        'Usando IA e análise de imagem, este módulo visa facilitar a contagem automatizada de animais durante o povoamento dos tanques.',
    },
    {
      key: 'panel6',
      title: 'Módulo de Sensores (Smarteye).',
      content:
        'Solução integrada de hardware e software para monitoramento ambiental com geração de relatórios automáticos.',
    },
    {
      key: 'panel7',
      title: 'Serviço de Consultoria Remota.',
      content:
        'Nossa equipe ajuda você a usar o sistema de forma eficiente, e pode indicar consultores parceiros para situações específicas.',
    },
    {
      key: 'panel8',
      title: 'Módulo Financeiro.',
      content:
        'Controle de compras, vendas e custos. Permite analisar lucros e planejar novos ciclos com previsões financeiras.',
    },
    {
      key: 'panel9',
      title: 'Módulo Comercial (LinkFish).',
      content:
        'Facilita negociações entre produtores e compradores com base em dados como espécie, preço, localização e peso dos animais.',
    },
  ];

  return (
    <Box>
      {questions.map((item) => (
        <CustomAccordion
          key={item.key}
          expanded={expanded === item.key}
          onChange={handleChange(item.key)}
        >
          <CustomSummary
            expandIcon={<ExpandMoreIcon sx={{ color: '#007A5E' }} />}
          >
            <Typography>{item.title}</Typography>
          </CustomSummary>
          <CustomDetails>
            <Typography>{item.content}</Typography>
          </CustomDetails>
        </CustomAccordion>
      ))}
    </Box>
  );
}
